import { createMarketplaceItemLink, createPublicItemDetailLink } from "@/router";
import type { CollectibleElastic } from "@/services/collectibles/elastic";
import type { PublicCollectionItem, PublicCollectionItem_CreatedFromCollectible, PublicCollectionItem_FeaturedListItem, PublicCollectionItem_ListItem, PublicCollectionItem_SearchListItem } from "@/services/collection/item/public/publicCollectionItemTypes";
import { type PriceNumeric } from "@/services/prices";

export const getMarketplacePrice = (item: PublicCollectionItem_ListItem | PublicCollectionItem_FeaturedListItem | PublicCollectionItem_SearchListItem): PriceNumeric | undefined => {
  const marketplaceItem = item.marketplaceItem;
  const quantity = item.marketplaceItem?.quantity ?? 0;

  if (marketplaceItem === null || quantity <= 0) {
    return undefined;
  } else {
    return marketplaceItem.price;
  }
};

export const getPublicLink = (item: PublicCollectionItem_ListItem | PublicCollectionItem_FeaturedListItem | PublicCollectionItem_SearchListItem, ownerNickname: string) => {
  const marketplaceItem = item.marketplaceItem;
  const quantity = item.marketplaceItem?.quantity ?? 0;

  if (marketplaceItem === null || quantity <= 0) {
    return createPublicItemDetailLink(item.id, item.name, ownerNickname);
  } else {
    return createMarketplaceItemLink(marketplaceItem.id, marketplaceItem.name);
  }
};

export const isCreatedFromCollectible = (item: PublicCollectionItem): item is PublicCollectionItem_CreatedFromCollectible => {
  return item.collectible !== null;
};

export const hasCollectibleElastic = (item: PublicCollectionItem): item is PublicCollectionItem & { collectibleElastic: CollectibleElastic } => {
  return item.collectibleElastic !== null;
};
